import { render, staticRenderFns } from "./MedicalStaff.vue?vue&type=template&id=0b7c49cc"
import script from "./MedicalStaff.vue?vue&type=script&lang=js"
export * from "./MedicalStaff.vue?vue&type=script&lang=js"
import style0 from "./MedicalStaff.vue?vue&type=style&index=0&id=0b7c49cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports